import React, { useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { FaCopy } from "react-icons/fa";

const QRCodeSection = () => {
  const qrRef = useRef(null);
  const linktreeUrl = "https://yourlinktree.com/yourusername";

  const downloadQRCode = () => {
    const canvas = qrRef.current.querySelector("canvas");
    const pngUrl = canvas
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    const downloadLink = document.createElement("a");
    downloadLink.href = pngUrl;
    downloadLink.download = "linktree-qr.png";
    downloadLink.click();
  };

  return (
    <div className="mt-10 flex justify-center">
      {/* Outer Gradient Border */}
      <div className="p-1 rounded-xl bg-gradient-to-r from-purple-500 via-pink-500 to-red-500 shadow-xl">
        {/* Inner Card */}
        <div className="text-center bg-white dark:bg-gray-800 p-4 rounded-xl shadow max-w-sm w-full">
          <h2 className="text-lg font-semibold text-gray-800 dark:text-white mb-4" role="heading" aria-level="2">
            Scan to Open My LinkTree
          </h2>
          <div ref={qrRef} className="inline-block bg-white p-2 rounded-lg">
            <QRCodeCanvas value={linktreeUrl} size={180} className="w-40 h-40" />
          </div>
          <button
  onClick={downloadQRCode}
  className="mt-4 text-white px-4 py-2 rounded-lg 
             bg-gradient-to-r from-pink-500 via-rose-500 to-purple-600 
             hover:from-indigo-600 hover:via-purple-700 hover:to-pink-700
             transition-all duration-300"
>
  Download QR Code
</button>

          <button
            onClick={() => navigator.clipboard.writeText(linktreeUrl)}
            className="mt-2 text-sm text-gray-600 dark:text-gray-300 hover:underline flex items-center justify-center gap-2"
          >
            <FaCopy /> Copy Link
          </button>
        </div>
      </div>
    </div>
  );
};

export default QRCodeSection;
